import React, { Component } from "react";
import { Link } from 'react-router-dom';
import * as routes from '../Constants/routes';

class TournamentRows extends Component {

  render() {

  var dgrdecks = this.props.tRows;
    return (
      dgrdecks.map(function(dgrDeck, i){
        return (
          dgrDeck.map(function(tourney, i){
            var dt=new Date(tourney.tournament.start_at);

            return (
            <tr>
              <td>
                <Link to={{
                  pathname: routes.TOURNAMENT + tourney.tournament.url,
                  state: { tournaments: dgrdecks}
                }}>{tourney.tournament.url}</Link>
              </td>
              <td>{tourney.tournament.name}</td>
              <td>{tourney.tournament.tournament_type}</td>
              <td>{dt.toLocaleString()}</td>
              <td>{tourney.tournament.check_in_duration}</td>
              <td>{tourney.tournament.participants_count}</td>
            </tr>
            )
          })
        )
      })
    );
  }
}

export default TournamentRows;



// WEBPACK FOOTER //
// ./src/Tournaments/TournamentRows.js